<template>
    <div class="widgets"  v-show="$route.query.expanded!=true && $route.query.expanded != 'true'">
        {{getCurrentWeek}}

        <div v-if="!roles.includes('LiteStudent')">
            <next-live-session 
             v-if="$route.name !== 'home' 
                && (localStorage.roles.includes('Student') 
                || localStorage.roles.includes('CampusStudent')
                || localStorage.roles.includes('GlobalMentor')
                || localStorage.roles.includes('Recruiter')
                || localStorage.roles.includes('Mentor')
                || localStorage.roles.includes('CampusMentor')                
                )" :location="'sidebar'">                
            </next-live-session>
        </div>

        <supervisor-sessions v-if="localStorage.roles.indexOf('Supervisor') > -1"></supervisor-sessions>
        <live-session-file-share v-if="roles.includes('Supervisor') || roles.includes('Mentor')" />
        <div v-if="!roles.includes('LiteStudent')">
            <class-alerts v-if="(roles.includes('CampusStudent') || roles.includes('Student')) && $root.preSemester == false"></class-alerts>        
        </div>
        <mentor-alerts v-if="roles.includes('Mentor') && !roles.includes('Supervisor')"></mentor-alerts>
        <supervisor-alerts v-if="roles.includes('Supervisor')"></supervisor-alerts>
        <live-session-file-share v-if="roles.includes('Student')" />
        <div v-if="!roles.includes('LiteStudent')">
            <workshops v-if="roles.includes('Student') || roles.includes('CampusStudent') || roles.includes('Supervisor') || roles.includes('Mentor')"></workshops>
        </div>
        <drop-ins v-if="!roles.includes('LiteStudent') && isNotRecruiter && !roles.includes('CampusInstructor')"></drop-ins>
        <forum-updates v-if="isNotRecruiter && !roles.includes('LiteStudent')"></forum-updates>

        <support v-if="roles.includes('CampusStudent') && !roles.includes('LiteStudent')"></support>        
     
        <div v-if="!roles.includes('LiteStudent')">
            <rocket-chat v-if="inProduction || rocketChatEnabled"></rocket-chat>
        </div>


        <div class="text-center image-container">
           <div class="sidebar-jar">
                  <div class="white sidebar-jar-image">
                  </div>
                  <div class="blue sidebar-jar-image">
                  </div>
            </div>
        </div>
    </div>
</template>

<script>

import NextLiveSession from './widgets/NextLiveSession.vue';
import LiveSessionFileShare from './widgets/LiveSessionFileShare.vue';
import SupervisorSessions from './widgets/SupervisorSessions.vue';
import courseCountdown from './widgets/CourseCountdown.vue';
import chatList from './widgets/ChatList.vue';
import RocketChat from './widgets/RocketChat.vue';
import support from './widgets/Support.vue';
import forumUpdates from './widgets/ForumUpdates.vue';
import classAlerts from './widgets/ClassAlerts.vue';
import MentorAlerts from './widgets/MentorAlerts.vue';
import SupervisorAlerts from './widgets/SupervisorAlerts.vue';
import Workshops from './widgets/Workshops.vue';
import DropIns from './widgets/DropIns.vue';

import moment from 'moment';
import { mapGetters } from 'vuex'

import courses from '../services/courses';
import assignments from '../services/assignments';
import terms from '../services/terms';

export default {

    data() {
        return {
            currentWeek: 0,

        }
    },
    components: {
        'course-countdown':courseCountdown,
        'support':support,
        'chat-list': chatList,
        'forum-updates': forumUpdates,
        'class-alerts': classAlerts,
        'next-live-session': NextLiveSession,
        'supervisor-sessions': SupervisorSessions,
        'rocket-chat': RocketChat,
        DropIns,
        Workshops,
        MentorAlerts,
        SupervisorAlerts,
        LiveSessionFileShare
    },
    mounted() {
        if (localStorage.terms !== 'null' && this.$route.name != 'campus-dashboard' && this.$route.name != 'home' && (localStorage.roles.includes('Student') || localStorage.roles.includes('Mentor') ) && localStorage.roles.indexOf('CampusStudent') === -1) {
            this.getTerms();
        }
    },
    watch: {
        currentWeek(week) {
            if (week && this.$route.name != 'campus-dashboard' && this.$route.name != 'home' && localStorage.roles.indexOf('Student') > -1 && localStorage.roles.indexOf('CampusStudent') === -1) {
                this.getTerms();
            }
        }
    },
    methods: {
            openChat(userName) {
                let url = window.chatUrl + '/home?user_id=' + localStorage.rocket_id + '&token=' + localStorage.rocket_token + '&origin=portal';
                
                if (userName) { url += '&dm=' + userName }

                let chatWindow = window.open(url, '_blank', 'location=0,height=570,width=960,scrollbars=yes,status=0');
            },
           getTerms() {
                var self = this;

                terms.get(this).then(function(response) {

                    let courseSets = {};
                    if (localStorage.selectedCourseSets) courseSets = JSON.parse(localStorage.selectedCourseSets);

                    let now = new Date();
                    let myTerms = localStorage.terms;
                    let termIds = myTerms.split(',');
                    let studentTerms = response.data.terms.filter(function(t) {
                        return termIds.indexOf(t.id) > -1;
                    }).map(function(t) {
                        if (t.courseSets && t.courseSets.length && localStorage.has_course_sets === 'true') {
                            let selected = courseSets[t.id];
                            if (selected) {
                                t.selectedCourseSet = selected;
                            } else {
                                t.selectedCourseSet = t.courseSets[0].id;
                            }
                        } else {
                            t.selectedCourseSet = null;
                        }
                        return t;
                    }).sort(function(a,b) {
                        return new Date(b.startDate) - new Date(a.startDate);
                    })


                    let data = {
                        type: 'terms',
                        data: studentTerms
                    }

                    self.$store.dispatch('populate', data);

                    let currentTerm = studentTerms.findIndex(function(t) {
                        return new Date(t.startDate) < now && new Date(t.endDate) > now;
                    });

                    if (currentTerm === -1) {
                        studentTerms = studentTerms.sort(function(a, b) { return new Date(b.endDate) - new Date(a.endDate)});
                        currentTerm = 0;
                    }

                    if (self.$route.query.term) {
                        currentTerm = studentTerms.findIndex(t => t.id == self.$route.query.term);
                    }

                    currentTerm = studentTerms[currentTerm];
                    self.$store.dispatch('populate', {type: 'currentTerm', data: currentTerm});
                    if (!localStorage.roles.includes('Mentor')) {
                        self.getCourses();
                    }
                    self.getWeeks();
                });
            },
            getWeeks() {
                var self = this;
                var term = this.$store.state.currentTerm;
                if (!term) return;
                var weeks = moment(term.endDate).diff(moment(term.startDate),'week') + 1;
                var startDate = moment(term.startDate).startOf('day').format('YYYY-MM-DD');
                var now = new Date();

                var pst = moment().tz('America/Vancouver').format('YYYY-MM-DD');

                var currentWeek;

                var isOngoing = new Date(term.startDate) < now && new Date(term.endDate) > now;

                if (isOngoing) {
                     currentWeek = moment(pst).diff(moment(startDate), 'weeks');
                } else {
                    // this is a past semester, so go back to week 1
                    currentWeek = 15;
                }

                var data = {
                    type: 'termWeeks',
                    data: weeks
                }

                self.$store.dispatch('populate', data);

                if (new Date(term.startDate) > new Date()) currentWeek = -1;

                data = {
                    type: 'currentWeek',
                    data: currentWeek
                }
                self.$store.dispatch('populate', data);

                data = {
                    type: 'realCurrentWeek',
                    data: currentWeek
                }

                self.$store.dispatch('populate', data)

            },
        getCourses() {
            var self = this;


            self.$store.dispatch('toggle',{type:'loading', boolean: true});
            let now = new Date();
            let termIds = localStorage.terms.split(',');


            let ongoingTerm = this.$store.getters.terms.filter(function(t) {
                return (termIds.indexOf(t.id) > -1) && (new Date(t.startDate) < now) && (new Date(t.endDate) > now);
            })[0];

            if (!ongoingTerm) {
                var studentTerms = this.$store.getters.terms.sort(function(a, b) { return new Date(b.endDate) - new Date(a.endDate)});
                ongoingTerm = studentTerms[0];
            }

            courses.get(this, null, null, ongoingTerm.id, ongoingTerm.type, null).then(function(response) {
                self.$store.dispatch('toggle',{type:'loading', boolean: false});

                if (!response.data.courses) return;
                
                let courses = response.data.courses.map(function(c) { c.assignments = []; return c; });

                assignments.getAll(this).then(function(res) {
                    res.data.assignments.forEach(function(a) {
                        let index = courses.findIndex(function(c) {
                            return c.id == a.instanceId
                        });
                        if (index > -1) {
                            courses[index].assignments.push(a)

                        }

                    });
                    self.$store.dispatch('populate', {type: 'courses', data: courses});

                });

            });
        }
    },
    computed: {
        isParticipant(participants) {
            console.log(participants);
        },
        isNotRecruiter() {
            const roles = JSON.parse(localStorage.getItem('roles'));
            return roles.length > 1 || !roles.includes('Recruiter');
        },
        inProduction() {
            if (localStorage.roles.includes('Admin')) return false;
            return window.location.hostname === "portal.tttc.ca"
        },
        roles() {
            return JSON.parse(localStorage.roles);
        },
        page() {
            return this.$route.name;
        },
        courses() {
            if (this.$store.state.courses.length > 1) {
                return this.$store.state.courses;
            } else {
                this.getCourses();
            }
        },
        getCurrentWeek() {
            this.currentWeek = this.$store.state.currentWeek
        },
        rocketChatEnabled() {
            if (window.location.hostname !== 'portal.tttc.ca') return false;
            return !!process.env.ROCKET_CHAT_ENABLED;
        }
    }
}
</script>

<style lang="css">
.widgets .panel {
    background:#222222;
}
.widgets .panel-heading,.widgets h2 {
        background: rgb(54, 54, 54);
}
.widgets .panel-heading {
    width:100%;
    transform: none;
    position: relative;
}
</style>

<style lang="scss">
    .widget {
        .toggle-widget {
            background: #474546;
            display:inline-block;
            border-radius:50%;
            width:3rem;
            height:3rem;
            line-height:3rem;
            text-align:center;
            color:#fff;
            position:absolute;
            right:-2rem;
            top:3rem;
            cursor: pointer;
            z-index:999;
        }
    }
</style>

<style lang="scss" scoped>

.widgets {
    width:275px;
    .live-session {
        padding-bottom:2rem;
    }
    // @media screen and (max-width: 1023px) {
    //     width:100%;
    //     .widget {
    //         width:25%;
    //         float:left;
    //         padding:0 1rem;
    //     }
    // }
    // @media screen and (max-width: 899px) {
    //     .widget {
    //         width:50%;
    //         float:left;
    //     }
    // }
    // @media screen and (max-width: 640px) {
    //     .widget {
    //         width:100%;
    //     }
    // }
}
.image-container {
    float:none;
    margin:3rem auto 0;
    width:112px;

}
.chat .panel-body {
    padding:0!important;
}


.sidebar-jar {
    position:relative;
    top:-50px;
    left:-25px;
    width:160px;
    height:180px;
    //display:flex;
    align-items: center;
    justify-content: center;
    margin-bottom: 50px;
}
.sidebar-jar-image {
    width:160px;
    height:180px;
    position:absolute;
    top:35%;
    background-size:cover;
    background-repeat: no-repeat;
    &.white {
        background-image:url('../assets/img/glow-jar-off.png');
    }
    &.blue {
        animation: jarrer 10s linear infinite;
        background-image:url('../assets/img/glow-jar-on.png');
    }
}

@keyframes jarrer {
  0% {
    opacity:0.0;
  }
  80% {
    opacity:0;
  }
  20% {
    opacity:0;
  }

  94% {
    opacity:0;
  }
  95% {
    opacity:.3;
  }
  96% {
    opacity:.4;
  }
  97% {
    opacity:0;
  }
  98% {
    opacity:.4;
  }
  99% {
    opacity:0;
  }
  100% {
    opacity:.1;
  }

}
</style>



// WEBPACK FOOTER //
// Widgets.vue?9abd5d42